/* eslint-disable quotes */
export default {
  studio_auth: 'Studio Authentication',
  studio_auth_type: 'Type',
  studio_auth_choose_type: 'Please select the authentication type:',
  studio_auth_cooper: 'Partner Enterprise Authentication',
  studio_auth_internal: 'Internal Studio Authentication',
  studio_auth_project_name: 'Game Name',
  studio_auth_project_owner: 'Game Director',
  company_auth: 'Enterprise Authentication',
  how_company_auth: 'Studio Authentication Guide',
  how_studio_auth: 'Authentication Guide',

  company_auth_desc:
    'Please first select the corresponding authentication  method according to your game type:If your project is independently developed by Tencent, a second-party cooperation project, or an agent distribution project, please select "Internal Studio Authentication".If your project belongs to the related business of external strategic cooperation enterprises, please select "Partner Enterprise Authentication".',
  company_auth_external_desc:
    'InGame currently only provides services for strategic cooperative enterprises. In order to ensure the safety of your property, you need to complete enterprise certification before online recharge and contract signing. A studio can only certify one enterprise, and the certification result will directly affect the ownership of account and service resources.',
  company_auth_internal_desc:
    'To ensure the accuracy of expense accounting data in InGame, each studio is required to complete title authentication. A studio can only be associated with one internal title and its corresponding KPI code.',
  company_auth_info:
    'The review results will be given within 3 - 5 working days. Please wait patiently.',
  company_start_auth: 'Start Authentication',
  company_re_auth: 'Restart Authentication',
  company_modify_auth: 'Modify Authentication',
  company_reject_title:
    'The materials you submitted contain the following errors',
  company_reject_text: ' failed verification',
  company_view_doc: 'View document',
  company_reject_mdm: 'enterprise name or unified social credit code',
  company_no_auth: 'Not Authenticated',
  company_status_pending: 'The authentication materials are under review',
  company_status_resolve: 'Authenticated Enterprise',
  company_status_reject: 'The authentication is not approved',

  company_cooper: 'Shenzhen city Tencent computer system Co. Ltd.',
  company_basic_info: 'Basic Info',
  company_name: 'Enterprise Name',
  company_area: 'Authentication Region',
  company_area_cn: 'Mainland China',
  company_area_info:
    'If you need to authenticate in regions other than Mainland China, please contact InGame.',
  company_info: 'Enterprise Info',
  company_desc: 'Enterprise Introduction',
  company_cert: 'Organizational Certificates',
  company_credit_code: 'Unified Social Credit Code',
  company_credit_code_info:
    "For government agencies, enterprises, public institutions, social organizations, and other organizations legally registered and incorporated within the People's Republic of China, a unique and permanent code identifier is issued nationwide. If not available, please fill in the business license number or other organization code.",

  company_input_wrong: 'Incorrect input format',

  company_license: 'Business License',
  company_contact_man: 'Contact Person',
  company_contact_name: 'Name',
  company_contact_id: 'ID',
  company_contact_phone: 'Phone',
  company_uploading_cert: 'uploading',
  company_upload_warn:
    'Upload the latest business license (in JPG or PNG format), no more than 4M',
  company_upload_err: 'The uploaded business license does not exceed 4M',
  company_status_error_warn:
    'The account status is abnormal, and this operation cannot be performed.',
};
